import { render, staticRenderFns } from "./humancloud.vue?vue&type=template&id=bd3f0e2a&scoped=true"
import script from "./humancloud.vue?vue&type=script&lang=js"
export * from "./humancloud.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd3f0e2a",
  null
  
)

export default component.exports